// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"e9d46a8f","403":"081d187a","551":"f08f88f6","672":"e954b9de","842":"8df647c5"}[chunkId] + ".chunk.js";
};